export default "__VITE_ASSET__ZvqDCTb8__"